export function huntZoneOverviewRows(club) {
  const zone = club?.hunt_zone;
  if (!zone || !(zone.short_label || zone.code)) return [];
  const rows = [{ label: 'Hunt zone', value: zone.short_label || zone.code }];
  if (zone.chip) {
    rows.push({ label: 'Season', value: zone.chip });
  }
  return rows;
}
